import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=7b4476c8&scoped=true"
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"
import style0 from "./chatList.vue?vue&type=style&index=0&id=7b4476c8&prod&scoped=true&lang=css"
import style1 from "./chatList.vue?vue&type=style&index=1&id=7b4476c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4476c8",
  null
  
)

export default component.exports